import { Deal } from '../types';

export const sampleDeals: Deal[] = [
  {
    id: 'deal-1',
    name: 'Tech Corp Acquisition',
    status: 'due_diligence',
    type: 'acquisition',
    value: 50000000,
    description: 'Strategic acquisition of AI software company to expand machine learning capabilities',
    targetCompany: {
      id: 't1',
      name: 'Tech Corp',
      industry: 'Technology',
      revenue: 10000000,
      employees: 100,
      location: 'San Francisco',
      description: 'Leading AI software company specializing in natural language processing'
    },
    acquiringCompany: {
      id: 'a1',
      name: 'Global Tech Inc',
      industry: 'Technology',
      revenue: 100000000,
      employees: 1000,
      location: 'New York',
      description: 'Fortune 500 technology company'
    },
    startDate: '2024-01-01',
    expectedCloseDate: '2024-06-30',
    team: [],
    documents: [],
    tasks: []
  },
  {
    id: 'deal-2',
    name: 'Manufacturing Merger',
    status: 'negotiation',
    type: 'merger',
    value: 75000000,
    description: 'Strategic merger to consolidate market position and achieve operational synergies',
    targetCompany: {
      id: 't2',
      name: 'Industrial Manufacturing Co',
      industry: 'Manufacturing',
      revenue: 25000000,
      employees: 250,
      location: 'Detroit',
      description: 'Industrial equipment manufacturer with strong presence in automotive sector'
    },
    acquiringCompany: {
      id: 'a2',
      name: 'Global Manufacturing',
      industry: 'Manufacturing',
      revenue: 150000000,
      employees: 1500,
      location: 'Chicago',
      description: 'Leading manufacturing company'
    },
    startDate: '2024-02-01',
    expectedCloseDate: '2024-08-31',
    team: [],
    documents: [],
    tasks: []
  },
  {
    id: 'deal-3',
    name: 'Healthcare Solutions Acquisition',
    status: 'prospect',
    type: 'acquisition',
    value: 120000000,
    description: 'Acquisition of healthcare software provider to enter digital health market',
    targetCompany: {
      id: 't3',
      name: 'HealthTech Solutions',
      industry: 'Healthcare Technology',
      revenue: 30000000,
      employees: 180,
      location: 'Boston',
      description: 'Provider of electronic health record systems and telemedicine platforms'
    },
    acquiringCompany: {
      id: 'a3',
      name: 'MedTech Global',
      industry: 'Healthcare',
      revenue: 500000000,
      employees: 3000,
      location: 'Minneapolis',
      description: 'Global healthcare technology and services provider'
    },
    startDate: '2024-03-15',
    expectedCloseDate: '2024-12-31',
    team: [],
    documents: [],
    tasks: []
  },
  {
    id: 'deal-4',
    name: 'Retail Chain Divestiture',
    status: 'closing',
    type: 'divestiture',
    value: 85000000,
    description: 'Strategic divestiture of non-core retail operations',
    targetCompany: {
      id: 't4',
      name: 'Urban Retail Group',
      industry: 'Retail',
      revenue: 45000000,
      employees: 500,
      location: 'Los Angeles',
      description: 'Regional retail chain with 50+ locations'
    },
    acquiringCompany: {
      id: 'a4',
      name: 'Retail Holdings LLC',
      industry: 'Retail',
      revenue: 250000000,
      employees: 2500,
      location: 'Dallas',
      description: 'National retail operator'
    },
    startDate: '2023-11-01',
    expectedCloseDate: '2024-04-30',
    team: [],
    documents: [],
    tasks: []
  },
  {
    id: 'deal-5',
    name: 'Fintech Integration',
    status: 'due_diligence',
    type: 'merger',
    value: 95000000,
    description: 'Merger with fintech startup to enhance digital payment capabilities',
    targetCompany: {
      id: 't5',
      name: 'PayTech Solutions',
      industry: 'Financial Technology',
      revenue: 15000000,
      employees: 85,
      location: 'Austin',
      description: 'Digital payments and blockchain technology provider'
    },
    acquiringCompany: {
      id: 'a5',
      name: 'Global Financial Services',
      industry: 'Financial Services',
      revenue: 750000000,
      employees: 5000,
      location: 'New York',
      description: 'Leading financial services provider'
    },
    startDate: '2024-02-15',
    expectedCloseDate: '2024-09-30',
    team: [],
    documents: [],
    tasks: []
  },
  {
    id: 'deal-6',
    name: 'Green Energy Acquisition',
    status: 'prospect',
    type: 'acquisition',
    value: 145000000,
    description: 'Strategic acquisition to expand renewable energy portfolio',
    targetCompany: {
      id: 't6',
      name: 'SolarTech Innovations',
      industry: 'Renewable Energy',
      revenue: 40000000,
      employees: 220,
      location: 'Phoenix',
      description: 'Solar technology and energy storage solutions provider'
    },
    acquiringCompany: {
      id: 'a6',
      name: 'Energy Solutions Global',
      industry: 'Energy',
      revenue: 900000000,
      employees: 4500,
      location: 'Houston',
      description: 'Integrated energy company focusing on renewable solutions'
    },
    startDate: '2024-03-01',
    expectedCloseDate: '2024-11-30',
    team: [],
    documents: [],
    tasks: []
  }
];